import { useCallback, useEffect, useRef } from "react";

/**
 * @param {useDidUpdateEffectCallback} effect
 * @param {string[]} deps
 */
export const useDidUpdateEffect = (effect, deps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callback = useCallback(effect, deps);
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) callback();
    else didMountRef.current = true;
  }, [callback]);
};
